import { GridLines as VisxGridLines } from '@visx/grid/lib/types';
import { Line } from '@visx/shape';

import Colors from '@dynatrace/strato-design-tokens/colors';

export type VisxGridLine = VisxGridLines[number];
export type VisxGridPoint = VisxGridLine['from'];

export const DEFAULT_STROKE_WIDTH = '1px';
export const DEFAULT_STROKE_COLOR =
  Colors.Background.Field.Neutral.DefaultActive;
export const HIGHLIGHTED_STROKE_WIDTH = '2px';
export const HIGHLIGHTED_STROKE_COLOR = Colors.Text.Neutral.Subdued;

export type GridLineProps = {
  from: VisxGridPoint;
  to: VisxGridPoint;
  highlight?: boolean;
};

export const GridLine = ({ from, to, highlight = false }: GridLineProps) => {
  let stroke = DEFAULT_STROKE_COLOR;
  let strokeWidth = DEFAULT_STROKE_WIDTH;

  if (highlight) {
    stroke = HIGHLIGHTED_STROKE_COLOR;
    strokeWidth = HIGHLIGHTED_STROKE_WIDTH;
  }

  return (
    <Line
      from={from}
      to={to}
      stroke={stroke}
      strokeWidth={strokeWidth}
      style={{
        shapeRendering: 'geometricPrecision',
      }}
    />
  );
};
